import React, { Component } from 'react';
import VideoFrame from './VideoFrame'
import Lightbox from 'lightbox-react';
import videos from '../data/videos';

import "../css/videogallery.css";

//https://github.com/treyhuffine/lightbox-react/blob/master/src/examples/cats/app.js
class VideoGallery extends Component {
    constructor() {
        super();

        this.state = {
            index: 0,
            isOpen: false
        };

        this.openLightbox = this.openLightbox.bind(this);
        this.closeLightbox = this.closeLightbox.bind(this);
        this.moveNext = this.moveNext.bind(this);
        this.movePrev = this.movePrev.bind(this);
        this.onImageLoadError = this.onImageLoadError.bind(this);
        this.getVideoFrames = this.getVideoFrames.bind(this);
        this.getVideoFrame = this.getVideoFrame.bind(this);
        this.pauseAllVideos = this.pauseAllVideos.bind(this);
    }

    openLightbox(event, obj) {
        //console.log(event);
        //console.log(obj);
        const openid = event.target.id.replace("video_thumb_", "");
        //console.log(openid);
        this.setState({ isOpen: true, index: openid });
        //let videoElms = document.getElementsByTagName('video');
        //videoElms[openid].play();
    }

    closeLightbox() {
        this.setState({ isOpen: false });
        this.pauseAllVideos();
    }

    moveNext() {
        this.setState({ index: (this.state.index + 1) % videos.length });
        this.pauseAllVideos();
        //let videoElms = document.getElementsByTagName('video');
        //videoElms[this.state.index].play();
    }

    movePrev() {
        this.setState({ index: (this.state.index + videos.length - 1) % videos.length });
        this.pauseAllVideos();
        //let videoElms = document.getElementsByTagName('video');
        //videoElms[this.state.index].play();
    }

    pauseAllVideos(){
        let videoElms = document.getElementsByTagName('video');
        for (let i=0; i<videoElms.length; i++){
            videoElms[i].pause();
        }
    }

    getVideoFrames() {
        let vf = [];
        videos.map(video => vf.push(<VideoFrame src={video.src} width={video.width} height={video.height} thumb={video.thumb} />));
        return vf;
    }

    getVideoFrame(video) {
        return <VideoFrame src={video.src} width={video.width} height={video.height} thumb={video.thumb} />;
    }

    onImageLoadError(imageSrc, _srcType, errorEvent) {
        console.error('Could not load image' + imageSrc, errorEvent); // eslint-disable-line no-console
    }

    render() {
        let lightbox = '';
        if (this.state.isOpen) {
            lightbox = (
                <Lightbox
                    mainSrc={this.getVideoFrame(videos[this.state.index])}
                    nextSrc={this.getVideoFrame(videos[(this.state.index + 1) % videos.length])}
                    prevSrc={this.getVideoFrame(videos[(this.state.index + videos.length - 1) % videos.length])}

                    mainSrcThumbnail={videos[this.state.index].thumb}
                    nextSrcThumbnail={videos[(this.state.index + 1) % videos.length].thumb}
                    prevSrcThumbnail={videos[(this.state.index + videos.length - 1) % videos.length].thumb}

                    onCloseRequest={this.closeLightbox}
                    onMovePrevRequest={this.movePrev}
                    onMoveNextRequest={this.moveNext}
                    onImageLoadError={this.onImageLoadError}

                    imageTitle={videos[this.state.index].title}
                    imageCaption={"Video " + (this.state.index + 1) + " di " + videos.length}
                />
            )
        };
        return (
            <div>
                <div>
                    <div className="row mdb-lightbox">
                        {
                            videos.map((video, index) =>
                                <div className="col-md-4" key={index}>
                                    <figure className="videocontent wow flipInY" data-wow-delay={"0." + index + "s"}>
                                        <img src={video.thumb} id={"video_thumb_" + index} alt={video.title} title={video.title} className="img-fluid" onClick={this.openLightbox} />
                                        <span className="video-duration">{video.duration}</span>
                                    </figure>
                                </div>
                            )}
                    </div>
                    {lightbox}
                </div>
            </div>
        );
    }
}

export default VideoGallery;


// WEBPACK FOOTER //
// ./src/components/VideoGallery.js